module.exports = __webpack_public_path__ + "img/5-reference-letter.ce95cce2.webp";